// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3gzvb","footer":"Form_footer__UpZhr"};